// extracted by mini-css-extract-plugin
export default {"button":"themeprimary_button__a2MSM"};